export default __webpack_public_path__ + "static/button-and-icon-53fdbaf3f2463cc04ac0ce2d8eefebd0.png";